<template>
  <Modal
    :id="uid"
    v-model:visible="visible"
    :header="t('errors.errors', 2)"
    @keypress.esc="onClose"
    @keypress.enter="onClose"
  >
    <div>
      <p v-for="(error, i) in errors" :key="i">
        {{ error }}
      </p>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useUid } from '@rygen/rygen-ui/composables';

import Modal from '@rygen/rygen-ui/components/ui/Modal.vue';

const visible = defineModel('visible', {
  type: Boolean,
  default: () => false,
});

const props = defineProps({
  errors: {
    type: Array as PropType<String[]>,
    default: () => [],
  },
});
const { errors } = toRefs(props);

const { t } = useI18n();
const uid = useUid('batch-check-call-reminder-errors-modal');

const onClose = () => {
  visible.value = false;
};
</script>
